import React from 'react'
import { Route,Routes } from "react-router-dom";

import Homepage from './components/routes/homepage.js';
import Contactpage from './components/routes/contactpage';
import Skillspage from './components/routes/skillspage.js';
import Projectpage from './components/routes/projectpage.js';
import Servicespage from './components/routes/servicespage.js';
import Webdevelopment from './components/servicestypes/webdevelopment/webdevelopment.js';
import Appdevelopment from './components/servicestypes/appdevelopment/appdevelopment.js';
import Uiuxdesign from './components/servicestypes/uiuxdesign/uiuxdesign.js';
import Desktopapplication from './components/servicestypes/desktopapplication/desktopapplication.js';
import Cloudintegration from './components/servicestypes/cloudintegartion/cloudintegration.js';
import Machinelearning from './components/servicestypes/machinelearning/machinelearning.js';
import Databasemanagement from './components/servicestypes/databasemanagement/databasemanagement.js';
import Digitalmarketing from './components/servicestypes/digitalmarketing/digitalmarketing.js';
import About from './components/about/about.js';
import Designpage from "./components/routes/designpage.js"
import Coursepage from './components/routes/coursepage.js';
import CanvasComponent from './components/profile/canvascomponent.js';
function App() {
    return (
      < >
        <Routes>
          <Route path="/" element={<Homepage/>}/>
          <Route path="/Skills" element={<Skillspage/>}/>
          <Route path="/Projects" element={<Projectpage/>}/>
          <Route path="/Services" element={<Servicespage/>}/>
          <Route path="/Contact" element={<Contactpage/>}/>
          <Route path="/Designs" element={<Designpage/>}/>
          
          
          </Routes>
          <Routes>
          <Route path="/CanvasComponent" element={<CanvasComponent/>}/>
          <Route path="/About" element={<About/>}/>
          <Route path="/web-development" element={<Webdevelopment/>} />
          <Route path="/app-development" element={<Appdevelopment/>} />
          <Route path="/ui-ux-design" element={<Uiuxdesign/>} />
          <Route path="/desktop-application-development" element={<Desktopapplication/>} />
          <Route path="/cloud-integration-dev-ops" element={<Cloudintegration/>} />
          <Route path="/machine-learning-ai-solutions" element={<Machinelearning/>} />
          <Route path="/database-management-integration" element={<Databasemanagement/>} />
          <Route path="/digital-marketing-solutions" element={<Digitalmarketing/>} />
          
          </Routes>
         

        
       
      </>
    ); 
  }
  
  export default App;
  